import React, {useState, useContext} from "react";
import {useAuth} from "../../contexts/AuthContext";
import StyleContext from "../../contexts/StyleContext";
import {login as apiLogin, register as apiRegister} from "../../services/api";

const AuthModal = ({onClose, onSuccess}) => {
  const {login} = useAuth();
  const {isDark} = useContext(StyleContext);
  const [tab, setTab] = useState("login");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [notice, setNotice] = useState("");

  const submit = async e => {
    e.preventDefault();
    setErr("");
    setNotice("");
    setBusy(true);
    try {
      let res;
      if (tab === "login") {
        res = await apiLogin(username.trim(), password);
      } else {
        res = await apiRegister(username.trim(), email.trim(), password);
      }
      if (!res || !res.token || !res.user) {
        throw new Error(res?.error || "Unexpected response");
      }
      login(res.user, res.token);
      if (res.reset) {
        setNotice("Password reset — you're signed in with the new one.");
      }
      if (onSuccess) onSuccess(res.user);
      onClose();
    } catch (e2) {
      setErr(e2.message || "Authentication failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={`modal-backdrop ${isDark ? "dark" : ""}`} onClick={onClose}>
      <div className={`modal ${isDark ? "dark" : ""}`} onClick={e => e.stopPropagation()}>
        <h3 className="modal__title">
          {tab === "login" ? "Welcome back" : "Create an account"}
        </h3>
        <p className="modal__subtitle">
          {tab === "login"
            ? "Sign in with your username or email."
            : "Forgot your password? Just re-register with the same email — it'll reset for you."}
        </p>
        <div className="modal__tabs">
          <button
            type="button"
            className={tab === "login" ? "active" : ""}
            onClick={() => { setTab("login"); setErr(""); }}
          >
            Login
          </button>
          <button
            type="button"
            className={tab === "register" ? "active" : ""}
            onClick={() => { setTab("register"); setErr(""); }}
          >
            Register
          </button>
        </div>
        <form onSubmit={submit}>
          <div className="modal__field">
            <label>{tab === "login" ? "Username or email" : "Username"}</label>
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoFocus
              required
              minLength={3}
              placeholder={tab === "login" ? "you@example.com or rashid" : "rashid"}
            />
          </div>
          {tab === "register" && (
            <div className="modal__field">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                placeholder="you@example.com"
              />
            </div>
          )}
          <div className="modal__field">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              minLength={6}
              placeholder="At least 6 characters"
            />
          </div>
          {err && <p className="modal__error">{err}</p>}
          {notice && <p className="modal__error" style={{
            background: "#e8f7ee",
            color: "#137333",
            borderColor: "#a9deb9"
          }}>{notice}</p>}
          <div className="modal__actions">
            <button type="button" className="modal__btn" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="modal__btn primary" disabled={busy}>
              {busy ? "Please wait…" : tab === "login" ? "Sign in" : "Create account"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AuthModal;
